<template>
  <div class="bg-dark p-4 rounded border border-success">
        <div class="panel-title mb-3 text-uppercase text-center fw-light fs-2 border-bottom border-success text-light">
            Sign Up
        </div>
        <div class="panel-body text-light">
            <div class="errors">
                <errors :errors="error_messages"></errors>
            </div>
            <form @submit.prevent="register">
                <div class="mb-3">
                    <label for="register-name" class="form-label">Name</label>
                    <input type="name" class="form-control" aria-describedby="nameHelp" v-model="name">
                </div>
                <div class="mb-3">
                    <label for="exampleInputEmail1" class="form-label">Email address</label>
                    <input type="email" class="form-control" aria-describedby="emailHelp" v-model="email">
                </div>
                <div class="mb-3">
                    <label for="exampleInputPassword1" class="form-label">Password</label>
                    <input type="password" class="form-control" v-model="password">
                </div>
                <div>
                    Already got an account ? <span class="register" @click="ChangePage()">Login here!</span>
                </div>
                <button type="submit" class="btn btn-primary">Register</button>
                </form>
        </div>
    </div>
</template>

<script>
import errors from './errors.vue'
export default {
    name: "register-panel",
    data () {
        return {
            message: 'hello world',
            name:'',
            email:'',
            password: ''
        }
    },
    props: ["error_messages"],
    methods: {
        ChangePage() {
            this.$emit('ChangePage', 'login')
        },
        register(){
            let data = {
                name: this.name,
                email: this.email,
                password: this.password
            }
            console.log(data,'<<<<< di register');
            this.$emit('register',data)
        }
    }
}
</script>

<style scoped>
span.register {
        cursor:pointer ;   
        font-weight:600
    }
    span.register:hover {
        color:rgb(60, 235, 153);
        text-decoration:underline;
    }
</style>